import { render, staticRenderFns } from "./DeletePeriodLabelButton.vue?vue&type=template&id=24dab46f&"
import script from "./DeletePeriodLabelButton.vue?vue&type=script&lang=js&"
export * from "./DeletePeriodLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports